// removed by extract-text-webpack-plugin
module.exports = {"root":"src-pages-Home-index-root-3nQU5"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/Home/index.css
 ** module id = 283
 ** module chunks = 0
 **/